import React, { memo, useMemo } from 'react';
import { Box, Button, Text, View, VStack } from 'native-base';
import Functions from '../../../utils/Functions';
import { useSafeParseDateFormat } from '../../../hooks';
import { styles } from '../../../theme';
import ClockMoney from '../../../assets/icons/Escrow/ClockMoney';
const END_NOTES_OPTION_ONE = timeFrame => `Freedom will automatically spread the shortage over ` + timeFrame + ` months beginning `;
const END_NOTES_OPTION_TWO = `Your new monthly payment beginning `;
const END_NOTES_OPTION_TWO_CONTINUED = ` will increase to account for the recent charges in your taxes and insurance.`;
const PAY_THE_SHRTG = `Pay escrow shortage of `;
const TAKE_NO_ACTION = `Take no action`;
const NOW = ` now`;
const PaymentOptionCard = _ref => {
  let {
    amount,
    type,
    date,
    shortage,
    onPayNowClick,
    timeFrame
  } = _ref;
  const effectiveDate = useSafeParseDateFormat(date);
  const optionSubTitle = useMemo(() => type === 'Option 1' ? TAKE_NO_ACTION : `${PAY_THE_SHRTG}${Functions.toUSD(shortage)}${NOW}`, [type, shortage]);
  const optionBody = useMemo(() => type === 'Option 1' ? `${END_NOTES_OPTION_ONE(String(timeFrame ?? ''))}${effectiveDate}.` : `${END_NOTES_OPTION_TWO}${effectiveDate}${END_NOTES_OPTION_TWO_CONTINUED}`, [type, timeFrame, effectiveDate]);
  return /*#__PURE__*/React.createElement(Box, {
    p: "3",
    borderColor: "#DCDCDC",
    borderWidth: "1",
    borderLeftWidth: "8",
    borderLeftColor: "primary.400",
    borderRadius: "md",
    w: {
      base: 'full',
      md: '1/2',
      lg: '350'
    },
    h: "72",
    m: "4",
    style: styles.shadow
  }, /*#__PURE__*/React.createElement(VStack, {
    flex: 1,
    alignItems: "center",
    justifyContent: 'space-between'
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: 'lg',
    accessibilityLabel: type,
    accessibilityRole: "text"
  }, type), /*#__PURE__*/React.createElement(Text, {
    bold: true,
    fontSize: "sm",
    textAlign: "center",
    accessibilityLabel: optionSubTitle,
    accessibilityRole: "text"
  }, optionSubTitle), /*#__PURE__*/React.createElement(Text, {
    fontSize: {
      base: 'xs',
      lg: 'sm'
    },
    textAlign: "center",
    lineHeight: "sm",
    accessibilityLabel: optionBody,
    accessibilityRole: "text"
  }, optionBody), /*#__PURE__*/React.createElement(Text, {
    fontSize: {
      base: 'xs',
      lg: 'sm'
    },
    fontWeight: "500",
    accessibilityLabel: `New Monthly Payment ${Functions.toUSD(amount)}`,
    accessibilityRole: "text"
  }, "New Monthly Payment : ", Functions.toUSD(amount)), type === 'Option 1' ? /*#__PURE__*/React.createElement(View, {
    accessibilityLabel: "icon",
    accessibilityRole: "image"
  }, /*#__PURE__*/React.createElement(ClockMoney, null)) : /*#__PURE__*/React.createElement(Button, {
    colorScheme: "primary",
    variant: "freedom",
    onPress: onPayNowClick,
    w: "48",
    _text: {
      fontWeight: 'bold',
      fontSize: 'lg'
    },
    accessibilityLabel: "pay now",
    accessibilityRole: "button"
  }, "PAY NOW")));
};
export default /*#__PURE__*/memo(PaymentOptionCard);
//# sourceMappingURL=index.js.map